import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import LazyScript from '@/core/browser/LazyScript.vue';
import useAltaPay from '@/shared/checkout/altapay/useAltaPay';
import AltaPayPaymentMethods from '@/shared/checkout/altapay/ui/AltaPayPaymentMethods.vue';
import { computed, onMounted, onUnmounted, watch } from 'vue';
import { usePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import { useCheckout as useB2CCheckout } from '@/b2c/checkout/useCheckout';
import { useCheckout as useB2BCheckout } from '@/b2b/checkout/useCheckout';
import authStore from '@/shared/auth/auth.store';
import $ from 'cash-dom';


export default /*#__PURE__*/_defineComponent({
  __name: 'AltaPay',
  props: {
    shopName: null,
    formStylingUrl: null,
    gatewayBaseUrl: null
  },
  setup(__props: any) {

const props = __props as {
    shopName?: string | undefined,
    formStylingUrl: string,
    gatewayBaseUrl: string,
}



const isB2B = computed<boolean>(() => authStore.isSignedInAsPartner);
const useCheckout = isB2B.value ? useB2BCheckout : useB2CCheckout;
const { summary } = useCheckout();
const { isHasSufficientPaymentsProviderSelected } = usePaymentOptions();
const { init, resetPayment, isHandlingRedirectData, initializing, isAllowedOnlinePayment, setInitialized } = useAltaPay();

let remainingToBePaidWatchHandle;
let isBankTransferWatchHandle;

const initAltaPay = async() => {
    setInitialized(false);
    remainingToBePaidWatchHandle = watch(() => summary.value?.remainingToBePaid?.rawAmount ?? 0, async() => {
        await init(props.formStylingUrl, props.shopName);
        setInitialized(true);
    }, { immediate: true });
};

onMounted(() => {
    $('body').addClass('ensure-overflow-visible-during-payment');
});

onUnmounted(() => {
    resetPayment();
    remainingToBePaidWatchHandle && remainingToBePaidWatchHandle();
    isBankTransferWatchHandle && isBankTransferWatchHandle();
    $('body').removeClass('ensure-overflow-visible-during-payment');
});


return (_ctx: any,_cache: any) => {
  return (__props.gatewayBaseUrl && _unref(isAllowedOnlinePayment))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LazyScript, {
          type: "module",
          src: `${__props.gatewayBaseUrl}/checkout/v1/js/AltaPaySDK.js`,
          onOnload: initAltaPay
        }, null, 8, ["src"]),
        _createElementVNode("div", {
          class: _normalizeClass(["transition-opacity duration-500", { 'opacity-50 select-none pointer-events-none': _unref(isHasSufficientPaymentsProviderSelected) || _unref(isHandlingRedirectData) || _unref(initializing) }])
        }, [
          _createVNode(AltaPayPaymentMethods)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})